import script from "./ChatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPage.vue?vue&type=script&setup=true&lang=js"

import "./ChatPage.vue?vue&type=style&index=0&id=173ad672&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173ad672"]])

export default __exports__